export const errorMessagReplaceRules = [
  [
    'The zip code you supplied failed validation.',
    'The billing zip code you supplied failed validation with your active payment method.'
  ]
  // you can add more string replace rules here
];

export const statusMessages = {
  504: 'The request timed out. Please reload the page and try again.'
  // you can add more status messages here
} as { [key: number]: string };
